import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { BaseSelectorComponent } from '@identic/core';
import { DataSourceFacade, DataSourceViewModel, DATA_SOURCE_DISPLAY_FIELD } from 'data-source/data-access';

export const DATA_SOURCE_SELECTOR_PATH ='data-source-select';
export const DATA_SOURCE_SELECTOR_ACTION = {
  actionName: 'data-source-select-event',
  title: 'Change Data source',
  icon: 'domain',
  colour: 'primary'
};

@Component({
  selector: 'data-source-selector',
  template: `
<div [class.container]="(selected$ | async) === undefined">
  <div [class.row]="(selected$ | async) === undefined">
    <div [class.col-6]="(selected$ | async) === undefined">
      <custom-selector *ngIf="loaded$ | async" class="ms-3"
        label="{{(selected$ | async) === undefined ? 'Choose' : 'Change'}} Data source..."
        [displayField]="itemDisplayField"
        [materialUI]="materialUI"
        [noPrompt]="noPrompt"
        [prompt]="prompt"
        noOptionsText="Sorry, but there are no Data source items to choose from"
        [showChoices]="showChoices"
        [selectOptions]="(list$ | async)!"
        [selectedItem]="selected$ | async"
        (change)="onChange($event)">
      </custom-selector>
    </div>
  </div>
</div>
`,
  styles: []
})
export class DataSourceSelectorComponent extends BaseSelectorComponent<DataSourceViewModel> {
  @Input() materialUI = true;
  @Input() noPrompt = true;
  @Input() prompt = '';

  itemDisplayField = DATA_SOURCE_DISPLAY_FIELD;
  itemFacadeSelectFn = (selectedItem: DataSourceViewModel) => this.facade.select(selectedItem.id!);

  constructor(
    route: ActivatedRoute,
    router: Router,
    private facade: DataSourceFacade,
  ) {
    super(route, router, facade);
  }
}
// console.log(`%cDataSourceSelectorComponent::ngOnInit`, 'background:yellow');
